module.exports = __webpack_public_path__ + "static/media/provider_isoftbet.1e8bf614.jpg";